module.exports = __webpack_public_path__ + "assets/photos/memories/frame-4--e4b4e69cc04371c1533da767148fb492.jpg";